import Graphic from '@arcgis/core/Graphic';
import GraphicsLayer from '@arcgis/core/layers/GraphicsLayer';
import GroupLayer from '@arcgis/core/layers/GroupLayer';
import { SyncSet } from 'cd-eft/framework/SyncSet';

export class DrawingsModel {
  public drawingsGroupLayer: GroupLayer;

  private drawingSet: SyncSet<Graphic>;

  constructor(drawingsGroupLayer: GroupLayer) {
    this.drawingsGroupLayer = drawingsGroupLayer;
    this.drawingSet = new SyncSet<Graphic>();
  }

  get drawingSyncSet() {
    return this.drawingSet;
  }

  get pendingEditCount(): number {
    return this.drawingSet.getPendingEditsCount();
  }

  loadDrawing(graphic: Graphic, title: string) {
    this.drawingSet.loadItem(graphic);

    // update the map contents
    const layer = this.constructGraphicsLayer(graphic, title);
    this.drawingsGroupLayer.add(layer);
  }

  addDrawing(graphic: Graphic, title: string) {
    this.drawingSet.insertItem(graphic);

    // update the map contents
    const layer = this.constructGraphicsLayer(graphic, title);
    this.drawingsGroupLayer.add(layer);
  }

  deleteDrawing(graphic: Graphic) {
    this.drawingSet.deleteItem(graphic);

    // update the map contents
    const layer = graphic.layer;
    if (this.drawingsGroupLayer.layers.includes(layer)) {
      this.drawingsGroupLayer.layers.remove(layer);
    } else {
      throw new Error('Unable to locate graphic in this context.');
    }
  }

  private constructGraphicsLayer(graphic: Graphic, title: string) {
    const graphicsLayer = new GraphicsLayer();
    graphicsLayer.title = title;
    graphicsLayer.add(graphic);
    return graphicsLayer;
  }

  clearSyncStatus() {
    this.drawingSyncSet.purgeDeletes();
    this.drawingSyncSet.clearSyncStatus();
  }
}
